<div class="b2b-login-password-form-b2b"><login-password-form-generic :logo="logo" :next="next" :back="handleBack"></login-password-form-generic></div>